module.exports = __webpack_public_path__ + "static/graphik-bold-798585dd090cbe09e9d3805abb3b02dd.woff";